import { CustomAxiosRequestConfig } from "../services";
import axiosInstance from "../services/axios";
import { IPortfolio } from "../types/portfolio";
import { Endpoints } from "./endpoint";
import { QueryObject } from "./global";

export const createPortfolioApi=async(payload:Partial<IPortfolio>)=>{
    const res = await axiosInstance.post(
        `${process.env.NEXT_PUBLIC_API}${Endpoints.PORTFOLIO.CREATE}`,
        payload,
        {
            requiresAuth: true // Custom property to skip auth
        } as CustomAxiosRequestConfig
    );
    return res.data;
}
export const removePortfolioApi=async(id:string)=>{
   
  const res = await axiosInstance.delete(
      `${process.env.NEXT_PUBLIC_API}${Endpoints.PORTFOLIO.CREATE}/${id}`,
     
      {
          requiresAuth: true // Custom property to skip auth
      } as CustomAxiosRequestConfig
  );
  return res.data;
}

export const updatePortfolioApi=async(payload:Partial<IPortfolio>)=>{
  const {_id,...data}=payload;
  const res = await axiosInstance.put(
       `${process.env.NEXT_PUBLIC_API}${Endpoints.PORTFOLIO.CREATE}/${_id}`,
      data,
      {
          requiresAuth: true // Custom property to skip auth
      } as CustomAxiosRequestConfig
  );
  return res.data;
}

export const getPortfolioApi=async(payload:Partial<QueryObject<{status:string,location:string,propertyType:string,year:string,sort:string,name:string}>>)=>{
    console.log(payload,">>>check <<<<")
    let url = `${process.env.NEXT_PUBLIC_API}${Endpoints.PORTFOLIO.CREATE}`;
    const queryParams = [];
  
    if (payload.page !== undefined) {
      queryParams.push(`page=${payload.page}`);
    }
    if(payload.location!==undefined&&payload.location!==""){
      queryParams.push(`location=${payload.location}`)
    }

     if(payload.status !== undefined && payload.status !==""){
      queryParams.push(`status=${payload.status.toLowerCase()}`); 
    }

    if(payload.sort!==undefined&&payload.sort!==""){
      queryParams.push(`sort=${payload.sort}`)
    }
    if(payload.year!==undefined&&payload.year!==""){
      queryParams.push(`year=${payload.year}`)
    }
    if(payload.propertyType!==undefined&&payload.propertyType!==""){
      queryParams.push(`propertyType=${payload.propertyType}`);
    }
     if(payload.status !== undefined && payload.status !==""){
      queryParams.push(`status=${payload.status.toLowerCase()}`); 
    }
    if(payload.name!==undefined&&payload.sort!==""){
      queryParams.push(`propertyName=${payload.name}`);
    }

    if (payload.limit !== undefined) {
      queryParams.push(`limit=${payload.limit}`);
    }
  //  queryParams.push(`populate=floorplan,documents,property,property.media,property.documents`);
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
  
    const res = await axiosInstance.get(url);
    return res.data;
}

export const getSinglePortfolioApi = async (id: string) => {
  const res = await axiosInstance.get(`${process.env.NEXT_PUBLIC_API}${Endpoints.PORTFOLIO.CREATE}/${id}`);
  return res.data;
};
